import {observer} from "mobx-react-lite";
import {DownloadCertificate} from "./DownloadCertificate";
export const ProviderPortal =  observer(()=> {

    return (
        <DownloadCertificate></DownloadCertificate>

    );
});